import host from './host.json';
import hosts from './hosts.json';

export default {
  hosts,
  host,
};
